import { render, staticRenderFns } from "./ShowBranch.vue?vue&type=template&id=2d615185&scoped=true"
import script from "./ShowBranch.vue?vue&type=script&lang=js"
export * from "./ShowBranch.vue?vue&type=script&lang=js"
import style0 from "./ShowBranch.vue?vue&type=style&index=0&id=2d615185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d615185",
  null
  
)

export default component.exports